import {Col, DatePicker, Form, Input, Row, Select} from "antd";
import React, {useEffect, useState} from "react";
import DgTimePiker from "./DG_Time_Picker";
import {getAllTenHang} from "../../../../api/weightSlip";
import {vnNormalize} from "../../../canMobile/weighing-slip/common/vnNormalize";
import moment from "moment";
import dayjs from "dayjs";
import RenderInput from "../../../../common/input/RenderInput";

const reg = /^\d*(\.\d*)?$/;
// const reg = /^-?\d*(\.\d*)?$/;

const Content = ({form, code, gioKTai, gioCTai, setGioKTai, setGioCTai}) => {

    const Option = Select
    const [hang, setHang] = useState([]);
    const [reload, setReload] = useState(false)

    useEffect(() => {
        getAllTenHang(code, null).then(r => {
            setHang(r)
        })
    }, [code])

    const validatorNumber = async (_, value) => {
        if (!value) {
            return Promise.resolve();
        }

        if (!reg.test(value)) {
            return Promise.reject(new Error('Giá trị phải là số'));
        }
        return Promise.resolve();
    };

    useEffect(()=>{
        const {coTai} = form.getFieldsValue()
        const {donGia} = form.getFieldsValue()
        const {tareWeight} = form.getFieldsValue()
        const {chietKhau} = form.getFieldsValue()
        if (coTai && tareWeight && reg.test(coTai) && reg.test(tareWeight)){
            form.setFieldValue("hang", (coTai - tareWeight))
        }else{
            form.setFieldValue("hang", undefined)
        }
        if (chietKhau && reg.test(chietKhau)){
            form.setFieldValue("sauCK", chietKhau)
        }else{
            form.setFieldValue("sauCK", undefined)
        }
        if (coTai && tareWeight && donGia && reg.test(coTai) && reg.test(tareWeight) && reg.test(donGia)){
            form.setFieldValue("thanhTien", donGia * (coTai - tareWeight))
        }else{
            form.setFieldValue("thanhTien", 0)
        }
    }, [reload, form])

    return (
        <div className={"mx-6"}>
            <Row gutter={24}>
                <Col span={12}>
                    <RenderInput form={form}
                                 name={"khachHang"}
                                 label={"Khách hàng"}
                                 placeholder={"Nhập tên khách hàng"}
                                 message={"Khách hàng là trường bắt buộc"}
                                 required={true} />
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={"Số xe"}
                        name="soXe"
                        rules={[
                            {
                                required: true,
                                message: "Số xe là trường bắt buộc"
                            },
                        ]}
                    >
                        <Input placeholder={"Nhập số xe"}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item
                        label={"Tên hàng"}
                        name="tenHang"
                        rules={[
                            {
                                required: true,
                                message: "Tên hàng là trường bắt buộc"
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                vnNormalize(option.props.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                                || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            placeholder="Chọn hoặc nhập"
                            onInputKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    form.setFieldValue("tenHang", e.target.value)
                                    setHang([e.target.value, ...hang]);
                                }
                            }}
                        >
                            {
                                hang.map(item => (
                                    <Option
                                        value={item} key={item}>{item}</Option>
                                ))
                            }
                        </Select>

                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={"Đơn giá(đ)"}
                        name="donGia"
                        rules={[
                            {validator: validatorNumber},
                        ]}
                    >
                        <Input placeholder={"Nhập đơn giá"}
                               onChange={()=>setReload(!reload)} />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item label="Ngày cân"
                               name="ngayCan"
                               initialValue={dayjs()}>
                        <DatePicker style={{ width: "95%" , height: 40}}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item
                        label={"Cân không tải"}
                        name="tareWeight"
                        rules={[
                            {validator: validatorNumber},
                        ]}
                    >
                        <Input addonAfter={"Kg"}
                               placeholder={"Nhập khối lượng cân không tải"}
                               onChange={()=>setReload(!reload)}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={"Giờ không tải"}
                        name="gioKTai"
                        initialValue={moment()}
                    >
                        <DgTimePiker value={gioKTai}
                                       onChange={(value) => {
                                           setGioKTai(moment(value))
                                       }} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item
                        label={"Cân có tải"}
                        name="coTai"
                        rules={[
                            {validator: validatorNumber},
                        ]}
                    >
                        <Input addonAfter={"Kg"}
                               placeholder={"Nhập khối lượng cân có tải"}
                               onChange={()=>setReload(!reload)}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={"Giờ có tải"}
                        name="gioCoTai"
                        initialValue={moment()}
                    >
                        <DgTimePiker value={gioCTai}
                                       onChange={(value) => {
                                           setGioCTai(moment(value))
                                       }}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item
                        label={"Chiết khấu%"}
                        name="chietKhau"
                        rules={[
                            {validator: validatorNumber},
                        ]}
                    >
                        <Input placeholder={"Nhập chiết khấu"} onChange={()=>setReload(!reload)}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={"Sau chiết khấu"}
                        name="sauCK"
                    >
                        <Input placeholder={"Sau chiết khấu"} disabled={true}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item
                        label={"Trọng lượng"}
                        name="hang"
                    >
                        <Input addonAfter={"Kg"} placeholder={"Trọng lượng"} disabled={true}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={"Thành tiền"}
                        name="thanhTien"
                        initialValue={0}
                    >
                        <Input disabled={true} placeholder={"Thành tiền"}/>
                    </Form.Item>
                </Col>
            </Row>
        </div>
    )
}

export default Content
